import Rest from '../../Rest'

export default class RequestFormIncidentService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v2/forms/'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  getGrid(name: String) {
    return this.get(`${name}/grid`)
  }

  getForm(name: String, id: any) {
    return this.get(`${name}/${id}`)
  }

  reprocessPdf(formType: String, formId: Number) {
    return this.post(`/${formType}/${formId}/reprocess_pdf`, {})
  }

  generateAndSendMail(formType: String, formId: Number) {
    return this.post(`/${formType}/${formId}/process_pdf`, {})
  }
}
